module.exports = __webpack_public_path__ + "static/media/commercial_request.08f0974a.svg";